module.exports = __webpack_public_path__ + "img/1949_uk.0ea6749c.svg";